module.exports = __webpack_public_path__ + "static/media/SCRIPT_ProSeDigitalResources(2)_1609253874951.34078eda.docx";